const dropdown = {
  init() {
    const langSelectors = document.getElementsByClassName("js-language-selector");

    if (langSelectors.length > 0) {
      Array.from(langSelectors).forEach((el) => {
        const root = document.documentElement;
        root.style.setProperty("--language-drop-width", `${el.offsetWidth}px`);
      });
    }

    const langGlobals = document.querySelectorAll(".language-global");

    langGlobals.forEach((langGlobal) => {
      const langMenuSelect = langGlobal.querySelector(".lang-menu-select-container");
      const langMenuList = langGlobal.querySelector(".lang-menu-select");

      if (!langMenuSelect || !langMenuList) return;

      function updateScrollState() {
        const atBottom =
          langMenuList.scrollHeight - langMenuList.scrollTop <=
          langMenuList.clientHeight + 1;
        langMenuSelect.classList.toggle("is-scrolled-bottom", atBottom);
      }

      langGlobal.addEventListener("click", function (event) {
        event.stopPropagation();
        const isOpening = langMenuSelect.style.display !== "block";

        langGlobals.forEach((other) => {
          const otherMenu = other.querySelector(".lang-menu-select-container");
          if (otherMenu && other !== langGlobal) {
            otherMenu.style.display = "none";
            other.classList.remove("active");
          }
        });

        langMenuSelect.style.display = isOpening ? "block" : "none";
        langGlobal.classList.toggle("active");
        if (isOpening) updateScrollState();
      });

      langMenuList.addEventListener("scroll", updateScrollState);

      langMenuSelect.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    });

    document.addEventListener("click", function () {
      langGlobals.forEach((langGlobal) => {
        const langMenuSelect = langGlobal.querySelector(".lang-menu-select-container");
        if (langMenuSelect) langMenuSelect.style.display = "none";
        langGlobal.classList.remove("active");
      });
    });
  },
};

export default dropdown;
